import { createContext } from "react";
import { useParams } from "react-router-dom";
import { useGetLatestOrderQuery } from "src/api/services/ordersApi";
import { PatientOrder } from "src/api/types";
import { MatchParam } from "src/constants/matches";

export const LatestOrderContext = createContext<PatientOrder | undefined>(
  undefined,
);

interface Props {
  children: React.ReactNode;
}

const LatestOrderProvider = ({ children }: Props) => {
  const { productId } = useParams<MatchParam<"PRODUCT_ID">>();

  const { data, isLoading } = useGetLatestOrderQuery({
    productId: productId ? Number(productId) : undefined,
  });

  if (isLoading === true) {
    return;
  }

  return (
    <LatestOrderContext.Provider value={data}>
      {children}
    </LatestOrderContext.Provider>
  );
};

export default LatestOrderProvider;
